import { fetcher } from 'fetcher!sofe';
import { isEmpty } from 'lodash';
import { OnboardingStatusData } from 'src/@types/common';

type OnboardingObject = {
  entity_type?: 'individual' | 'organization' | 'soleProprietorship';
  first_name?: string;
  last_name?: string;
  legal_name?: string;
  ein?: string;
  address?: {
    address_1?: string;
    address_2?: string;
    locality?: string;
    region?: string;
    postal_code?: string;
  };
  phone_number?: string;
  website?: string;
  team_can_key_in_cards?: boolean;
  confirm_surcharge?: boolean;
  accept_terms?: boolean;
};

export const getAdyenOnBoardingLink = (onBoardingInfo: OnboardingObject) => {
  const { team_can_key_in_cards, confirm_surcharge, ...rest } = onBoardingInfo;
  return fetcher('/api/canopy_payments/account/onboarding_link', {
    method: 'POST',
    body: isEmpty(onBoardingInfo)
      ? {}
      : team_can_key_in_cards && Object.keys(onBoardingInfo).length === 1
        ? { team_can_key_in_cards }
        : { account: { ...rest }, team_can_key_in_cards, confirm_surcharge },
  }).then((response: { link: string }) => response.link);
};

export const deleteAdyenOnBoardingLink = () => {
  return fetcher('/api/canopy_payments/account/reset', {
    method: 'DELETE',
  });
};

export const getAdyenTermsAndConditions = () => {
  return fetcher('/api/canopy_payments/onboarding/terms', { responseType: 'blob' });
};

export const getPaymentsOnboardingStatus = () => {
  return fetcher('/api/canopy_payments/onboarding/status').then(
    (response: { status: OnboardingStatusData }) => response.status
  );
};
